<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Migration Pembayaran Angsuran Completed!
      </div>
      <b-card no-body>
      </b-card>
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  validations: {},
  data() {},
  components: { Loading, myNumber },
  computed: {},
  watch: {},
  created: async function () {},
  methods: {},
};
</script>
